/*
  Collection of custom validation rules for trades form
*/
import {required, numeric, requiredIfFieldContains} from '../../helpr/generic-validation-rules';
import {optionsMember} from "./registration-form-validation-rules";

export const workBankDetailsObj = obj => {
  return {
    fields: {
      primaryContactSalutation: {
        value: obj.primaryContact.salutation,
        style: {}
      },
      primaryContactLastName: {
        value: obj.primaryContact.lastName,
        style: {}
      },
      primaryContactFirstName: {
        value: obj.primaryContact.firstName,
        style: {}
      },
      primaryContactMiddleName: {
        value: obj.primaryContact.middleName,
        style: {}
      },
      primaryContactEmailAddress: {
        value: obj.primaryContactEmailAddress,
        style: {}
      },
      primaryContactTelNo: {
        value: obj.primaryContactTelNo,
        style: {}
      },
      nature: {
        value: obj.nature,
        style: {}
      },
      tin: {
        value: obj.tin,
        style: {}
      },
      taxStatus: {
        value: obj.taxStatus,
        style: {}
      },
      accountNumber: {
        value: obj.accountNumber,
        style: {}
      },
      bankName: {
        value: obj.bankName,
        style: {}
      },
      bankBranch: {
        value: obj.bankBranch,
        style: {}
      }
    },
    dynamicFields: {}
  }
}

/*
  Trade Transfer Form (Transfer Instruction) Fields Configuration
  Validation rules setup for use-validation hook
*/
export const workBankDetailsValidator = {
  /* Set Default Values plus their respective validation rules*/
  fields: {
    primaryContactSalutation: [required],
    primaryContactLastName: [required],
    primaryContactFirstName: [required],
    primaryContactMiddleName: [required],
    primaryContactEmailAddress: [required],
    primaryContactTelNo: [required],
    nature: [required],
    tin: [required],
    taxStatus: [required],
    accountNumber: [required],
    bankName: [required],
    bankBranch: [required]
  },
  dynamicFields: {}
}

